import { isDevelopmentEnvironment } from "../estada-config";
import { startDebugTextTranslation } from "./debugTextTranslation";
import { initialUiLanguage } from "../models/uiLanguage";

let itxData = new Map<string, string>();

export let missingKeys = new Set<string>();

// Guards against out-of-order concurrent loadLanguage() calls (e.g. the initial boot-time
// load overlapping with a user-triggered language switch) overwriting newer translations
// with stale ones.
let loadRequestSeq = 0;

export async function changeLanguage(language: string) {
  return state.settings.setUiLanguage(language);
}

export async function loadLanguage(): Promise<boolean> {
  const language = (globalThis.state?.settings?.uiLanguage ?? initialUiLanguage()).split("-")[0];

  const requestId = ++loadRequestSeq;

  function addChildrenToMap(parentName: string | undefined, json: any, map: Map<string, string>) {
    for (let i in json) {
      const name = parentName ? `${parentName}.${i}` : i;
      const level1 = json[i];
      if (typeof level1 == "string") {
        map.set(name, level1);
      } else {
        addChildrenToMap(name, level1, map);
      }
    }
  }

  try {
    const response = await fetch(`${import.meta.env.BASE_URL}locales/${language}/translation.json`);
    if (!response.ok) {
      throw new Error(`Could not load translations (${response.status} ${response.statusText})`);
    }

    const json = await response.json();

    // a newer loadLanguage() call has started in the meantime - discard this stale response
    if (requestId !== loadRequestSeq) {
      return false;
    }

    console.log("itx data loaded");

    const newData = new Map<string, string>();
    addChildrenToMap(undefined, json, newData);
    itxData = newData;
    return true;
  } catch (ex: any) {
    alert(`error loading itx (${language}) data:` + ex.toString());
    return false;
  }
}

export function noItx(value: string) {
  if (isDevelopmentEnvironment()) {
    if (globalThis.state?.settings.debugTranslation) {
      startDebugTextTranslation();

      return `{[!${value}!]}`;
    }
  }

  return value;
}

export function itx1(key: string) {
  const t = itxData.get(key);
  return t || "";
}

export function itx(x: string, y?: string, vars?: any, varsInMarkdownBold?: boolean): string {
  let res: string = "";

  if (isDevelopmentEnvironment() && globalThis.state?.settings.debugTranslation) {
    startDebugTextTranslation();

    let translatedValue = itx1(x);

    if (translatedValue == "") {
      ///// wenn der default wert zurückgegeben wurde
      missingKeys.add(`${state.settings.language}- ${x}: ${y}`);
      res = `{[?${x}: ${y}?]}`;
    } else {
      //// wenn der wert übersetzt wurde
      res = `{[${translatedValue}]}`;
    }

    if (vars) {
      for (let i in vars) {
        vars[i] = vars[i].replaceAll("{[", "");
        vars[i] = vars[i].replaceAll("]}", "");
      }
    }
  } else {
    res = itx1(x) || y || "";
  }

  if (vars) {
    for (let i in vars) {
      if (varsInMarkdownBold) {
        res = res.replaceAll(i, `**${vars[i]}**`);
      } else {
        res = res.replaceAll(i, vars[i]);
      }
    }
  }

  return res;
}

export function T(key: string, defaultValue?: string, vars?: any) {
  return itx(key, defaultValue, vars);
}

export function noT(defaultValue: string) {
  return noItx(defaultValue);
}
